module.exports = __webpack_public_path__ + "img/doc.bbe91833.svg";